import { Inject, Injectable } from '@angular/core';
import * as moment from 'moment';
import { MAT_DATE_LOCALE } from '@angular/material/core';

@Injectable({
  providedIn: 'root'
})
export class MomentLocalizedDateService {
  private _supportedFormats = ['date', 'dateTime', 'time', 'longDateTime'];

  constructor(@Inject(MAT_DATE_LOCALE) private _dateLocale: string) {
    moment().locale(this._dateLocale.toLowerCase());
  }

  format(value, format?) {
    if (!value || value.length === 0 || !moment(value).isValid()) {
      return value;
    }
    moment.locale(this._dateLocale.toLowerCase());
    return moment(value).format(this._getMomentFormat(format));
  }

  private _getMomentFormat(format) {
    if (!format || this._supportedFormats.indexOf(format) === -1 || format === 'date') {
      return 'l';     // Locale Date
    } else if (format === 'dateTime') {
      return 'l, LT'; // Locale Date and Time
    } else if (format === 'time') {
      return 'LT';    // Locale Time
    } else {
      return 'LLL';   // e.g June 1, 2022 5:33 PM
    }

  }
}
